<script lang="ts">
    import type TikTokPostEntity from "@apps/tiktok/entities/TikTokPostEntity";
    import { getTypedContext } from "@lib/svelte-typed-context";

    import BaseButton from "@components/Buttons/BaseButton.svelte";
    import Icon from "@components/Icon.svelte";
    import Image from "@components/Image/Image.svelte";
    import { ModalToken } from "@components/Modal/ModalManager";
    import { modalManagerContextKey } from "@components/Modal/ModalManager/constants";
    import T from "@components/T.svelte";
    import VideoPlayerPlayIcon from "@components/VideoPlayer/icons/VideoPlayerPlayIcon.svelte";

    export let post: TikTokPostEntity;
    export let postModalToken: ModalToken<{ id: number }>;
    const modalManager = getTypedContext(modalManagerContextKey);
    const handleOpen = () => {
        modalManager.openModal(postModalToken, undefined, { id: +post.postId });
    };
</script>

<button class="gw-tt-preview" on:click={handleOpen}>
    <!-- Image preview -->
    <div class="gw-tt-preview__image-wrap">
        <Image objectFit="cover" src={post.thumbnailUrl} alt={post.title} />
        <div class="gw-tt-preview__backdrop">
            {#if post.tags.length !== 0}
                <BaseButton class="gw-tt-preview__shop-it">
                    <T
                        namespace="tiktok.critical.TikTokGalleryWidget"
                        translationKey="shop_it"
                    />
                </BaseButton>
            {:else}
                <Icon
                    title="Play"
                    width="30px"
                    height="30px"
                    class="gw-tt-preview__play-icon"
                >
                    <VideoPlayerPlayIcon />
                </Icon>
            {/if}
        </div>
    </div>
    <!-- TikTok Logo -->
    <svg
        class="gw-tt-preview__tiktok-logo"
        width="36"
        height="40"
        viewBox="0 0 36 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12.1786 20.5554C8.93204 20.5554 6.30921 23.1054 6.35718 26.2307C6.38917 28.2364 7.52466 29.9779 9.19592 30.9497C8.62817 30.1023 8.29232 29.0994 8.27633 28.0188C8.22835 24.8935 10.8512 22.3435 14.0977 22.3435C14.7375 22.3435 15.3532 22.4446 15.9289 22.6234V16.3651C15.3292 16.2796 14.7135 16.2329 14.0977 16.2329C14.0658 16.2329 14.0418 16.2329 14.0098 16.2329V20.8353C13.434 20.6565 12.8183 20.5554 12.1786 20.5554V20.5554Z"
            fill="#F00044"
        />
        <path
            d="M26.2124 1.78809H26.1644H24.5011C24.9809 4.12815 26.3323 6.16502 28.2195 7.54885C26.98 5.95512 26.2284 3.96489 26.2124 1.78809V1.78809Z"
            fill="#F00044"
        />
        <path
            d="M36 11.3117C35.3683 11.3117 34.7605 11.2495 34.1608 11.1406V15.6264C31.9858 15.6264 29.8747 15.2144 27.8916 14.3903C26.6122 13.8616 25.4207 13.1853 24.3252 12.369L24.3572 26.1995C24.3412 29.3092 23.0777 32.2246 20.7908 34.4247C18.9276 36.2128 16.5686 37.3556 14.0098 37.721C13.4101 37.8065 12.7943 37.8532 12.1786 37.8532C9.44382 37.8532 6.83698 36.9902 4.71793 35.3965C4.95782 35.6764 5.2137 35.9485 5.49358 36.2128C7.79655 38.4207 10.8512 39.6413 14.1057 39.6413C14.7215 39.6413 15.3372 39.5946 15.9369 39.5091C18.4958 39.1437 20.8547 38.0009 22.7179 36.2128C25.0049 34.0127 26.2683 31.0973 26.2843 27.9876L26.1644 14.1571C27.2519 14.9734 28.4434 15.6575 29.7308 16.1784C31.7219 16.9947 33.833 17.4145 36 17.4145"
            fill="#F00044"
        />
        <path
            d="M5.4696 19.6767C7.74858 17.4766 10.7792 16.256 14.0098 16.2327V14.5767C13.4101 14.4912 12.7943 14.4446 12.1786 14.4446C8.91606 14.4446 5.85343 15.6651 3.55046 17.8886C1.28746 20.0732 -0.00795963 23.0585 3.68031e-05 26.1605C3.68031e-05 29.2857 1.27147 32.2167 3.56645 34.4323C3.93428 34.7822 4.31012 35.1087 4.70994 35.4041C2.90274 33.3128 1.91918 30.7007 1.91119 27.9486C1.91918 24.8466 3.20661 21.8613 5.4696 19.6767V19.6767Z"
            fill="#08FFF9"
        />
        <path
            d="M34.1608 11.1406V9.47686H34.1448C31.9218 9.47686 29.8747 8.76162 28.2275 7.54883C29.6588 9.38357 31.7539 10.6897 34.1608 11.1406Z"
            fill="#08FFF9"
        />
        <path
            d="M13.7699 33.5228C14.5295 33.5617 15.2572 33.4606 15.9289 33.2507C18.2479 32.5122 19.9191 30.4131 19.9191 27.9409L19.9271 18.6894V1.78809H24.5011C24.3812 1.20502 24.3172 0.614171 24.3092 0H18.008V16.8936L18 26.145C18 28.6172 16.3287 30.7163 14.0098 31.4549C13.3381 31.6726 12.6104 31.7736 11.8507 31.727C10.8832 31.6726 9.97957 31.3927 9.19592 30.9418C10.1795 32.4189 11.8587 33.4218 13.7699 33.5228V33.5228Z"
            fill="#08FFF9"
        />
        <path
            d="M14.0098 37.721C16.5686 37.3556 18.9276 36.2127 20.7908 34.4247C23.0777 32.2245 24.3412 29.3092 24.3572 26.1994L24.3252 12.3689C25.4127 13.1852 26.6042 13.8694 27.8916 14.3902C29.8827 15.2066 31.9938 15.6264 34.1608 15.6264V11.1406C31.7539 10.6897 29.6588 9.38359 28.2274 7.54885C26.3403 6.16502 24.9809 4.12815 24.5091 1.78809H19.9271V18.6817L19.9191 27.9331C19.9191 30.4053 18.2479 32.5044 15.9289 33.243C15.2572 33.4606 14.5295 33.5617 13.7699 33.5151C11.8507 33.414 10.1795 32.4111 9.19592 30.9418C7.52467 29.9777 6.38917 28.2285 6.35719 26.2228C6.30921 23.0975 8.93204 20.5475 12.1786 20.5475C12.8183 20.5475 13.434 20.6486 14.0098 20.8274V16.225C10.7792 16.2483 7.74857 17.4689 5.46958 19.669C3.20659 21.8536 1.91117 24.8389 1.91917 27.9331C1.91917 30.6852 2.90273 33.2974 4.71792 35.3887C6.84497 36.9824 9.44381 37.8454 12.1786 37.8454C12.7943 37.8531 13.41 37.8065 14.0098 37.721V37.721Z"
            fill="white"
        />
    </svg>
</button>

<style lang="postcss">
    .gw-tt-preview {
        position: relative;
        width: 325px;
        height: 574px;

        overflow: hidden;
        border: 1px solid #e2e3e4;
        border-radius: 7px;
        background: #ffffff;
        cursor: pointer;

        padding: 0;

        &__tiktok-logo {
            position: absolute;
            z-index: 1;
            top: 11px;
            right: 17px;
        }

        &__image {
            &-wrap {
                position: relative;
                width: 100%;
                height: 574px;
            }
        }

        &__backdrop {
            display: block;
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            transition: opacity var(--gw-default-transition);
            opacity: 0;
            background: var(--gw-light-dark-color);
        }

        &:hover .gw-tt-preview__backdrop {
            opacity: 1;
        }

        & :global(.gw-tt-preview__shop-it) {
            position: absolute;
            top: 50%;
            left: 50%;
            padding: 6px 9px;
            transform: translate(-50%, -50%);
            border: 2px solid;
            color: var(--gw-white-text-color);
            font-size: 0.9em;
            font-weight: bold;
            line-height: normal;
        }

        & :global(.gw-tt-preview__play-icon) {
            display: block;
            position: absolute;
            z-index: 1;
            top: 50%;
            left: 50%;
            width: 38px;
            height: 48px;
            margin: -24px 0 0 -19px;
        }
    }
</style>
